import type { MouseEvent } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchCurrentUser } from '@wundo/client/auth.ts';
import { showDemoUnavailable } from './demoUnavailable.ts';

export interface HeldBackProps {
  'aria-disabled'?: true;
  onClick?: (event: MouseEvent) => void;
}

/**
 * Props for a link or button a demo organisation sees but cannot use: greyed
 * out, and a click says why instead of going there. Outside a demo, or for
 * something the demo does allow, it adds nothing.
 */
export function useDemoHoldBack(): (heldBack: boolean) => HeldBackProps {
  const { data: user } = useQuery({
    queryKey: ['currentUser'],
    queryFn: fetchCurrentUser,
  });
  const demo = user?.demo === true;

  return (heldBack) =>
    demo && heldBack
      ? {
          'aria-disabled': true,
          onClick: (event) => {
            event.preventDefault();
            showDemoUnavailable();
          },
        }
      : {};
}
